import { render, staticRenderFns } from "./HomeContactForm.vue?vue&type=template&id=705858d2&"
import script from "./HomeContactForm.vue?vue&type=script&lang=js&"
export * from "./HomeContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports